import storage from 'app/utils/storage';
import { parse } from 'cookie';
import env from '.env.json';
import axios from 'axios';

export interface ResultAPI {
  success: boolean;
  data: any;
};

export const apiRequest = (path: string, methodType: string, data = {}, multipart = false, rootUrl = '') => {
  let headers;
  headers = {};
  headers['tokenApi'] = env.API_KEY;
  headers['oorigin'] = env.ROOT_URL;
  headers['Accept'] = 'application/json';

  if (typeof storage != 'undefined') {
    headers['language'] = storage.get('language');
  }

  if (typeof window != 'undefined') {
    const cookies = parse(document.cookie || '');
    headers['Authorization'] = `Bearer ${cookies?.auth_token}`;
  }

  if (multipart) {
    headers['content-type'] = 'multipart/form-data';
  }

  return new Promise(
    (resolve, reject) => {
      axios({
        method: methodType,
        url: `${rootUrl || env.URL_API}${path}`,
        data: data,
        headers: headers
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(function (error) {
          if (error && error.response && error.response.status === 401) {
            console.warn('unauthorized, logging out ...' + path);
          }
          reject(error.response?.data);
        });
    });
};
